import { useLazyQuery } from "@apollo/client";
import { useEffect, useState } from "react";
import { FaPrint } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { ClearSpecificForm } from "../../../Store/FormDataReducer/FormFieldFunctions";
import { LRDetailsWithMemoDetailsAndTrackingDetails } from "../../../Utils/AllPagesQuriesAndMutations";
import { LoadTable } from "../../Components";
import { Tabs } from "../../Components/AdminRequestSupportComponents/Tabs";
import Button from "../../Components/Button/Button";
import Input from "../../Components/Input/Input";
import { useModalContext } from "../../Components/Reactportal/ModalContext";
import PortalFooter from "../../Components/Reactportal/PortalFooter";
import Reactportal from "../../Components/Reactportal/Reactportal";
import { WarningToast } from "../../Components/ToastComponent/RectHotToast";
import { ConvertDateValues } from "../../custom_hooks/ChangeDateValues";
import "./LRTrack.scss";

const tabItems = [{ name: "PickupMemo" }, { name: "Memo" }, { name: "DeliveryMemo" }];

const LRTrack = ({ setSearchClicked }) => {
  const Form_Key = "LR_Track";
  const { pushModal, popModal } = useModalContext();
  const [toggle, setToggle] = useState(false);
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState("");
  const [activeTab, setActiveTab] = useState(0);
  const [formData, setFormData] = useState([]);
  const [LrLMSBill, setLrLMSBill] = useState([]);
  const [isClickGo, setIsClickGo] = useState(false);

  const handleChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const [
    GetLRDetailsWithMemoDetailsAndTrackingDetails,
    { loading: getLRDetailsWithMemoDetailsAndTrackingDetailsLoading },
  ] = useLazyQuery(LRDetailsWithMemoDetailsAndTrackingDetails, {
    fetchPolicy: "network-only",
  });

  const handleGo = () => {
    console.log(selectedValue);
    if (selectedValue) {
      setIsClickGo(true);
      GetLRDetailsWithMemoDetailsAndTrackingDetails({
        variables: { lrNo: selectedValue },
      }).then(({ data }) => {
        let LRDetails = { ...data?.getLRDetailsWithMemoDetailsAndTrackingDetails };
        console.log(LRDetails, "LRDetailsLRDetailsLRDetails");
        if (LRDetails) {
          setFormData(LRDetails);
          const data = [
            {
              _id: LRDetails?._id,
              Trans: "LR",
              No: LRDetails?.LR_No,
              Date: LRDetails?.Date,
              Branch: LRDetails?.Branch_Code_Data?.Name,
              User: LRDetails?.CreatedBy,
              Freight: LRDetails?.Freight_Amount,
              Print: <FaPrint />,
            },
          ];

          // if (LRDetails?.LrDeliveryMemosData?._id) {
          //   data.push({
          //     _id: LRDetails.LrDeliveryMemosData._id,
          //     Trans: "Delivery",
          //     No: LRDetails.LrDeliveryMemosData.DRS_No,
          //     Date: LRDetails.LrDeliveryMemosData.Date,
          //     Branch: LRDetails.LrDeliveryMemosData.Branch_Code_Data?.Name,
          //     User: LRDetails.LrDeliveryMemosData.CreatedBy,
          //     Freight: LRDetails.LrDeliveryMemosData.Freight_Amount,
          //     Print: <FaPrint />,
          //   });
          // }

          if (LRDetails?.LrLMSSalesBillData?._id) {
            data.push({
              _id: LRDetails.LrLMSSalesBillData._id,
              Trans: "Bill",
              No: LRDetails.LrLMSSalesBillData.Invoice_No,
              Date: LRDetails.LrLMSSalesBillData.Date,
              Branch: LRDetails.LrLMSSalesBillData.Branch_Code_Data?.Name,
              User: LRDetails.LrLMSSalesBillData.CreatedBy,
              Freight: LRDetails.LrLMSSalesBillData.Freight_Amount,
              Print: <FaPrint />,
            });
          }

          setLrLMSBill(data);
        }
      });
    } else {
      WarningToast("Please enter the LR number");
    }
  };

  useEffect(() => {
    setToggle(true);
  }, []);

  useEffect(() => {
    if (toggle) {
      pushModal(Form_Key);
    }
  }, [toggle, Form_Key, pushModal]);

  const closeFormFunction = () => {
    popModal(Form_Key);
    setToggle(false);
    setSearchClicked(false);
    setSelectedValue("");
    ClearSpecificForm(dispatch, Form_Key);
  };

  const footerContent = (
    <PortalFooter
      renderContent={() => <></>}
      disabled={false}
      handleformclose={() => {
        closeFormFunction();
        setToggle(!toggle);
      }}
      loadingState={false}
    />
  );

  const transactionsD = [
    {
      _id: 1,
      Rec_Date: "",
      Rec_Truck_No: "",
      Rec_Branch: "",
      From_Branch: "",
      User: "",
      Godown: "",
    },
  ];

  return (
    <>
      <div className="LRTrack_Form_Main_Container">
        <Reactportal
          TypeOfPortal={"LR Track"}
          FoooterContent={footerContent}
          open={toggle}
          onClose={closeFormFunction}
          Form_Key={Form_Key}
        >
          <div className="LRTrack_Form_DetailsContainer">
            {getLRDetailsWithMemoDetailsAndTrackingDetailsLoading && <div className="loader-line-div" />}
            <div className="formContainer">
              <div className="LR_Track_Search_Box_Container1">
                <div className="LR_Track_Search_Box">
                  <Input
                    EMTQuery=""
                    checked=""
                    InputConfig={{}}
                    type="Text Box(Single Line)"
                    name="LR_No"
                    handleBlur={() => {}}
                    handleInputChange={(e) => handleChange(e)}
                    label={"LR No"}
                    modalform={true}
                    Iconinside={true}
                    value={selectedValue}
                  />
                </div>
                <div>
                  <Button name="gobutton" text="GO" action={handleGo}></Button>
                </div>
              </div>
            </div>
            {isClickGo ? (
              formData?._id ? (
                <>
                  <div className="LRDeliveryDetails">
                    <div className="LRDeliverDetailsSection1">
                      <div className="fields">
                        <span>Delivery : </span>
                        <span className="fields_Value">{formData?.Delivery}</span>
                      </div>
                      <div className="fields">
                        <span>Lr Type : </span>
                        <span className="fields_Value">{formData?.Service_Type_Data?.Mode}</span>
                      </div>
                      <div className="fields">
                        <span>Type : </span>
                        <span className="fields_Value">{formData?.Freight_Type}</span>
                      </div>
                      {/* <div className="fields">
                      <span>Disc : </span>
                      <span className="fields_Value">0</span>
                    </div> */}
                      <div className="fields">
                        <span>Value Rs : </span>
                        <span className="fields_Value">{formData?.Total}</span>
                      </div>
                      <div className="fields">
                        <span>Booking Id : </span>
                        <span className="fields_Value">{formData?.Unique_Id}</span>
                      </div>
                    </div>
                    <div className="LRDeliverDetailsSection2">
                      <div className="fields">
                        <span>Status: </span>
                        <span className="fields_Value">{formData?.Current_Stage}</span>
                      </div>
                    </div>
                  </div>
                  <div className="LRDetailsContainer">
                    <div className="LRDetailsContainer1">
                      <div className="LRDetailsContainersSection1">
                        <div className="Details">
                          <div className="fields">
                            <span>Consignor</span>
                            <span>: {formData?.Consignor_Data?.Name || formData?.Consignor_Data?.Business_Name}</span>
                          </div>
                          <div className="fields">
                            <span>From City</span>
                            <span>: {formData?.From_City}</span>
                          </div>
                          <div className="fields">
                            <span>Truck</span>
                            <span>:</span>
                          </div>
                          <div className="fields">
                            <span>Freight By</span>
                            <span>: {formData?.Freight_Type}</span>
                          </div>
                          <div className="fields">
                            <span>Receiver</span>
                            <span>: {formData?.Consignee_Data?.Name || formData?.Consignee_Data?.Business_Name}</span>
                          </div>
                          <div className="fields">
                            <span>Center</span>
                            <span>
                              : {formData?.LR_Center_Data?.Center_Name ? formData?.LR_Center_Data?.Center_Name : "-"}
                            </span>
                          </div>
                          <div className="fields">
                            <span>MemoTrans TruckNo</span>
                            <span>:</span>
                          </div>
                          <div className="fields">
                            <span>Unloading Date</span>
                            <span>:</span>
                          </div>
                        </div>
                        <div className="Details">
                          <div className="fields">
                            <span>Consignee</span>
                            <span>
                              :{" "}
                              {formData?.Consignee_Data
                                ? formData?.Consignee_Data?.Name || formData?.Consignee_Data?.Business_Name
                                : "-"}
                            </span>
                          </div>
                          <div className="fields">
                            <span>To City</span>
                            <span>: {formData?.To_City}</span>
                          </div>
                          <div className="fields">
                            <span>Driver</span>
                            <span>:</span>
                          </div>
                          <div className="fields">
                            <span>InvNo</span>
                            {formData?.Invoice_Numbers ? <span>: {formData?.Invoice_Numbers}</span> : "-"}
                          </div>
                          <div className="fields">
                            <span>Transporter</span>
                            <span>:</span>
                          </div>
                          <div className="fields">
                            <span>Bill Party</span>
                            <span>
                              : {formData?.Bill_Consignor_Data?.Name || formData?.Bill_Consignor_Data?.Business_Name}
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="LRDetailsContainersSection2">
                        <div className="Details">
                          <div className="fields">
                            <span>Bal No. :</span>
                            <span>: 0</span>
                          </div>
                        </div>
                      </div>
                      <div className="LRDetailsContainersSection3">
                        <LoadTable
                          data={ConvertDateValues(LrLMSBill)}
                          title={Form_Key}
                          settings={false}
                          options={false}
                          select={false}
                        />
                      </div>
                    </div>
                    <div className="LRDetailsContainer2">
                      <div className="LRDetailsContainersSection1">
                        <div className="HeaderTitle">{"Invoice Material Details"}</div>
                        {formData?.LrInvoiceMaterialData ? (
                          <LoadTable
                            data={ConvertDateValues(formData?.LrInvoiceMaterialData)}
                            title={Form_Key}
                            settings={false}
                            options={false}
                            select={false}
                          />
                        ) : (
                          <p className="DataNotAvailable">Data not Available</p>
                        )}
                      </div>
                      <div className="LRDetailsContainersSection2">
                        <Tabs
                          tabs={tabItems}
                          ActiveIndex={activeTab}
                          SetTabPage={(tabName) => {
                            const index = tabItems.findIndex((t) => t.name === tabName);
                            setActiveTab(index);
                          }}
                        />

                        <div className="tab-slider">
                          {tabItems.map(() => {
                            console.log(activeTab, "activeTabactiveTab");
                            let tableData = [];
                            if (activeTab === 0) {
                              tableData = formData?.LrPickupMemosData?._id ? [formData?.LrPickupMemosData] : [];
                            } else if (activeTab === 1) {
                              tableData = formData?.LrConnectionMemosData?.length
                                ? formData?.LrConnectionMemosData
                                : [];
                            } else if (activeTab === 2) {
                              tableData = formData?.LrDeliveryMemosData?._id ? [formData?.LrDeliveryMemosData] : [];
                            }

                            return (
                              <div className="tab-content">
                                {formData?.LrInvoiceMaterialData ? (
                                  <LoadTable
                                    data={ConvertDateValues(tableData)}
                                    title={Form_Key}
                                    settings={false}
                                    options={false}
                                    select={false}
                                    Tab={activeTab}
                                  />
                                ) : (
                                  <p className="DataNotAvailable">Data not Available</p>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="LRPaymentAndMemoReceiveDetailsContainer">
                  <div className="LRPaymentAndMemoReceiveDetailsSection1">
                    <div className="LRPaymentAndMemoReceiveDetails_Header">
                      <div className="HeaderTitle">{"Payment Details"}</div>{" "}
                      <div className="ReceivedInfo">
                        Received : <span className="receivedDetail">No (Pending: 104961)</span>
                      </div>
                    </div>
                    <LoadTable data={transactionsD} title={Form_Key} settings={false} options={false} select={false} />
                  </div>
                  <div className="LRPaymentAndMemoReceiveDetailsSection2">
                    <div className="LRPaymentAndMemoReceiveDetails_Header">{"Memo Receive List"}</div>
                    <LoadTable data={transactionsD} title={Form_Key} settings={false} options={false} select={false} />
                  </div>
                </div>
                <div className="LRDeliveryExtraInfo">
                  <div className="LrDeliveryExtraInfoSection1">
                    <div>
                      <Input
                        EMTQuery=""
                        checked=""
                        InputConfig={{}}
                        type="Text Box(Single Line)"
                        name="Delivery_At"
                        handleBlur={() => {}}
                        handleInputChange={(e) => handleChange(e)}
                        label={"Delivery At :"}
                        modalform={true}
                        Iconinside={true}
                      />
                    </div>
                    <div>
                      <Input
                        EMTQuery=""
                        checked=""
                        InputConfig={{}}
                        type="Text Box(Single Line)"
                        name="Del_Note"
                        handleBlur={() => {}}
                        handleInputChange={(e) => handleChange(e)}
                        label={"Del. Note. :"}
                        modalform={true}
                        Iconinside={true}
                      />
                    </div>
                  </div>

                  <div className="LrDeliveryExtraInfoSection2">
                    <div>
                      <Input
                        EMTQuery=""
                        checked=""
                        InputConfig={{}}
                        type="Text Box(Single Line)"
                        name="Note"
                        handleBlur={() => {}}
                        handleInputChange={(e) => handleChange(e)}
                        label={"Note :"}
                        modalform={true}
                        Iconinside={true}
                      />
                    </div>
                    <div>
                      <Input
                        EMTQuery=""
                        checked=""
                        InputConfig={{}}
                        type="Text Box(Single Line)"
                        name="Extra_Status"
                        handleBlur={() => {}}
                        handleInputChange={(e) => handleChange(e)}
                        label={"Extra Status :"}
                        modalform={true}
                        Iconinside={true}
                      />
                    </div>
                  </div>
                  <div className="LrDeliveryExtraInfoSection3">
                    <div>
                      <Input
                        EMTQuery=""
                        checked=""
                        InputConfig={{}}
                        type="Text Box(Single Line)"
                        name="Del_Msg"
                        handleBlur={() => {}}
                        handleInputChange={(e) => handleChange(e)}
                        label={"Del. Msg. :"}
                        modalform={true}
                        Iconinside={true}
                      />
                    </div>
                  </div>
                  <div className="LrDeliveryExtraInfoSection4"></div>
                </div> */}
                </>
              ) : (
                <p className="Lr_Error_Message_Container">No data found for provided LR Number </p>
              )
            ) : (
              <p className="Lr_Error_Message_Container">Search the LR with LR Number</p>
            )}
          </div>
        </Reactportal>
      </div>
    </>
  );
};

export default LRTrack;
